export default __webpack_public_path__ + "static/media/banner1.ebd3bb73.jpg";